export const ProohFormDataTargets = {
  // Prooh
  sellerCreateMediaForm: "seller-create-media-form",
  sendConfirmationForm: "send-confirmation-form",
  addCaptiveAreaForm: "add-poi-captive-area-form",
  tabContentPreviewForm: "tab-content-preview-form",
};
